/* eslint-disable spaced-comment */
module.exports = {
  agrupadorDescuentos: [
    {
      id: 1,
      descripcion: 'Tipo 1',
    },
    {
      id: 2,
      descripcion: 'Tipo 2',
    },
    {
      id: 3,
      descripcion: 'Tipo 3',
    },
    {
      id: 4,
      descripcion: 'Tipo 4',
    },
    {
      id: 5,
      descripcion: 'Tipo 5',
    },
  ],
  //? TIPOS DE PARAMETROS SOLICITUD DE IMPORTE
  PARAMETRO_AREA: 1,
  PARAMETRO_ANTIGUEDAD: 2,
  PARAMETRO_GENERAL: 3,
  PARAMETRO_REEMBOLSOGASTOS: 4,
  PARAMETRO_ESPECIALES: 5,
  PARAMETRO_DESTAJO: 6,
  PARAMETRO_PUESTO: 7,
  PARAMETRO_DEVOLUCION_DESCUENTOS_INDEBIDOS: 8,
  PARAMETRO_RETROACTIVOS_ESPECIFICOS: 9,
  PARAMETRO_ISR_SUBSIDIADO: 11,

  //? ESTADOS GLOBALES
  ESTATUS_ACTIVO: 1,
  ESTATUS_EN_PROCESO: 2,
  ESTATUS_INACTIVO: 3,
  ESTATUS_AUTORIZADO: 4,
  ESTATUS_CANCELADO: 5,
  ESTATUS_RECHAZADO: 6,

  //? ESTADO_EMPLEADO
  ESTADO_PRE_ALTA: 1,
  ESTADO_ACTIVO: 2,
  ESTADO_LIQUIDACION: 3,
  ESTADO_SUSPENDIDO: 4,
  ESTADO_BAJA: 5,
  ESTADO_REINGRESO: 6,

  //? TIPO DE PRESUPUESTO
  TIPO_PRESUPUESTO_INGRESO: 1,
  TIPO_PRESUPUESTO_EGRESO: 2,

  //? METODO DE PAGO
  METODO_DE_PAGO_EFECTIVO: 1,
  METODO_DE_PAGO_TRANSFERENCIA_ELECTRONICA_DE_FONDOS: 3,

  //? TIPOS DE DEPOSITO
  TIPO_DE_DEPOSITO_DEBITO: 1,
  TIPO_DE_DEPOSITO_CLABE: 2,

  //? SIN ESTUDIOSS
  SIN_ESTUDIOS: 1,

  //? CONTRIBUCION
  CONTRIBUCION_GRAVADO: 1,
  CONTRIBUCION_EXCENTO: 2,
  CONTRIBUCION_PARCIALMENTE: 3,
  CONTRIBUCION_NO_APLICA: 4,

  //? INCIDENCIAS
  INCIDENCIA_AUSENTISMO: 1,
  INCIDENCIA_VACACIONES: 2,
  INCIDENCIA_INCAPACIDAD: 3,
  INCIDENCIA_PAGOLABORAL: 4,

  //? ESTADO PLAZA
  ESTADO_PLAZA_ACTIVA: 1,
  ESTADO_PLAZA_AUTORIZADA: 2,
  ESTADO_PLAZA_DISPONIBLE: 3,
  ESTADO_PLAZA_SUSPENDIDA: 4,
  ESTADO_PLAZA_ASIGNADA: 5,
  ESTADO_PLAZA_POR_ASIGNAR: 6,
  ESTADO_PLAZA_DESASIGNADA: 7,
  ESTADO_PLAZA_INACTIVA: 8,

  //? TIPO DE EMPLEADO
  TIPO_DE_EMPLEADO_JUBILADO: 15,
  TIPO_DE_EMPLEADO_PENSIONADO: 14,

  //? TIPO DE FUNCION
  TIPO_DE_FUNCION_JUBILADO: 4,
  TIPO_DE_FUNCION_PENSIONADO: 5,

  //? DESTINO DEL DESCUENTO
  DESTINO_DEL_DESCUENTO_PAGO_A_TERCEROS: 1,
  DESTINO_DEL_DESCUENTO_PARA_DEVOLUCION_AL_EMPLEADO: 2,

  //? RETENCIONES DE PAGO
  ESTADO_PAGO_LIBERADO: 2,
  ESTADO_PAGO_RETENIDO: 3,
  ESTADO_PAGO_CANCELADO: 4,

  //? SUSPENSIONES DE PAGO
  ESTADO_PAGO_SUSPENDIDO: 2,
  ESTADO_PAGO_LIBERADA: 3,
  BAJA_DE_EMPLEADO: 4,

  //? TIPO DE INCIDENCIAS UNIDADES
  TIPO_DE_INCIDENCIAS_UNIDAD_MINUTOS: 1,
  TIPO_DE_INCIDENCIAS_UNIDAD_HORAS: 2,
  TIPO_DE_INCIDENCIAS_UNIDAD_DIAS: 3,

  //? PROCESOS ASINCRONOS
  PROCESO_ASINCRONO_ANTIGUEDAD: 1,

  //? TIPOS DE DESCUENTOS
  DESCUENTO_RECURRENTE_Y_VARIABLE: 1,
  DESCUENTO_TEMPORAL: 2,
  DESCUENTO_UNICOS: 3,
  DESCUENTO_RECURRENTE_Y_FIJO: 4,
  DESCUENTO_DE_CALCULO_EXTERNO: 5,

  //? ESTATUS DE TIMBRADO
  ESTATUS_TIMBRADO_SIN_TIMBRAR: 1,
  ESTATUS_TIMBRADO_CON_ERROR: 2,
  ESTATUS_TIMBRADO_TIMBRADO_PARCIAL: 3,
  ESTATUS_TIMBRADO_TIMBRADO: 4,
  ESTATUS_TIMBRADO_CANCELADO: 5,
  ESTATUS_TIMBRADO_EN_BUZON: 6,
  // SystiCloud: resultado no confirmado; nunca se reenvía (lo resuelve la conciliación)
  ESTATUS_TIMBRADO_PENDIENTE_CONCILIAR: 7,

  //? TIPOS DE MOVIMIENTO DE EMPLEADO
  TIPO_MOVIMIENTO_ALTA: 1,
  TIPO_MOVIMIENTO_BAJA: 2,
  TIPO_MOVIMIENTO_CAMBIO: 3,

  //? TIPOS DE NOMINA
  NOMINA_ORDINARIA: 1,
  NOMINA_EXTRAORDINARIA: 2,

  //? SUBTIPO DE NOMINA
  SUBTIPO_NOMINA_NINGUNO: 1,
  SUBTIPO_NOMINA_EXTEMPORANEO: 2,
  SUBTIPO_NOMINA_LIQUIDACION: 3,
  SUBTIPO_NOMINA_AGUINALDO: 4,
  SUBTIPO_NOMINA_ANTICIPO_AGUINALDO: 5,
};
